// Enabling Muliple language in OneTrust preference center
(function (site) {
  Drupal.behaviors.oneTrustBehavior = {
    attach: function (context) {
      var date = new Date();
      var langClassMap = {
        EN: {
          lang: 'en-MY',
          switchLang: 'ms',
          btnClass: '.ot-sdk-show-settings-btn-en'
        },
        MS: {
          lang: 'ms',
          switchLang: 'en-MY',
          btnClass: '.ot-sdk-show-settings-btn-my'
        }
      };
      var otLang = $.cookie('onetrustLangSwitch');

      if (otLang in langClassMap) {
        $('html').attr('lang', langClassMap[otLang]['lang']);
        site.elcEvents.addListener('onetrust:loaded', function () {
          const btnClass = langClassMap[otLang]['btnClass'];

          if (window.OneTrust) {
            $(btnClass).trigger('click');
          }
          date.setTime(date.getTime() + 2000);
          $.cookie('onetrustLangSwitch', 1, { expires: date });
        });
      }

      for (const lang in langClassMap) {
        const btnClass = langClassMap[lang]['btnClass'];

        (function (l) {
          $(btnClass, context).on('click', function () {
            const switchLang = langClassMap[l]['switchLang'];

            if (!$.cookie('onetrustLangSwitch') && $('html').attr('lang') === switchLang) {
              date.setTime(date.getTime() + (3600 * 1000));
              // Set cookie for an hour
              $.cookie('onetrustLangSwitch', l, { expires: date });
              $('.close-icon').trigger('click');
              location.reload();
            } else if (window.OneTrust) {
              window.OneTrust.ToggleInfoDisplay();
            }
          });
        })(lang);
      }
    }
  };
}(window.site || {}));
